import { useGetLmsTrainingReportCostsQuery, useAddLmsTrainingReportCostMutation, useDeleteLmsTrainingReportCostMutation } from '../../../../api';
import useTrainingReportSubListData from './useTrainingReportSubListData';

/**
 * Rapor detayındaki maliyet satırları. Artık ortak `useTrainingReportSubListData` factory'sinin
 * ince bir sarmalayıcısı (bkz. o dosyadaki not) — davranış aynı, yalnızca 3 hook arasındaki
 * kopya kod kaldırıldı. Bkz. docs/LMS-Egitim-Raporlari-API.md §4.
 */
const useTrainingReportCostsData = (trainingReportId) => {
    const { itemsApi, isLoading, isFetching, isAdding, isDeleting, addItem, removeItem, refetch } = useTrainingReportSubListData({
        trainingReportId,
        useGetQuery: useGetLmsTrainingReportCostsQuery,
        useAddMutation: useAddLmsTrainingReportCostMutation,
        useDeleteMutation: useDeleteLmsTrainingReportCostMutation,
        i18nNamespace: 'costs'
    });

    return {
        costsApi: itemsApi,
        isLoading,
        isFetching,
        isAdding,
        isDeleting,
        addCost: addItem,
        removeCost: removeItem,
        refetch
    };
};

export default useTrainingReportCostsData;
